const authenticationMethods = [
  {
    id: 1,
    method: 'mobiilivarmenne-ftn',
    name: 'Mobiilivarmenne',
    logo: 'mobiilivarmenne'
  },
  {
    id: 2,
    method: 'ftn-nordea-auth',
    name: 'Nordea',
    logo: 'nordea'
  },
  {
    id: 3,
    method: 'ftn-danskebank-auth',
    name: 'Danske Bank',
    logo: 'danskebank'
  },
  {
    id: 4,
    method: 'ftn-op-auth',
    name: 'Osuuspankki',
    logo: 'osuuspankki'
  },
  {
    id: 5,
    method: 'ftn-spankki-auth',
    name: 'S-Pankki',
    logo: 'spankki'
  },
  {
    id: 6,
    method: 'ftn-aktia-auth',
    name: 'Aktia',
    logo: 'aktia'
  },
  {
    id: 7,
    method: 'ftn-alandsbanken-auth',
    name: 'Ålandsbanken',
    logo: 'alandsbanken'
  },
  {
    id: 8,
    method: 'ftn-omasp-auth',
    name: 'Oma Säästöpankki',
    logo: 'omasaastopankki'
  },
  {
    id: 9,
    method: 'ftn-sp-auth',
    name: 'Säästöpankki',
    logo: 'saastopankki'
  },
  {
    id: 10,
    method: 'ftn-pop-auth',
    name: 'POP Pankki',
    logo: 'poppankki'
  }
];

export default authenticationMethods;



// WEBPACK FOOTER //
// ./src/components/BankSelection/methods.js